module.exports = __webpack_public_path__ + "static/media/moveAccountsArrowIcon.68d9f803.svg";